import React, {Component} from 'react';

import fallback from '../../assets/images/maps.png'

export default class SVGIconComponent extends Component {
  render() {
    const image = this.props.image || fallback;
    return (
            <div className="custom-marker-div">
                <img className="custom-marker-img" src={image}></img>
            </div>
    );
  }
}